/**
 * The `groupBy` function in TypeScript takes an array of items and groups them based on a specified
 * property.
 * @param {T[]} array - The `array` parameter is an array of elements of type `T` that you want to
 * group based on a specific property.
 * @param property - The `property` parameter in the `groupBy` function is a function that takes an
 * element of the array as input and returns a string. This string is used as the key to group the
 * elements of the array.
 */
export const groupBy = <T>(array: T[], property: (x: T) => string): { [key: string]: T[] } =>
  array.reduce((memo, item) => {
    const key = property(item);
    memo[key] = memo[key] || [];
    memo[key].push(item);
    return memo;
  }, {} as { [key: string]: T[] });
